import React, { useContext, useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { AiOutlineMinus } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { ProductContext } from "../contexts/ProductContext";

// function Cart({ hideCart }) {
function Cart() {
  const { isAuthenticated } = useContext(AuthContext);
  const {setCartOpen } = useContext(ProductContext);

  const [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("cartItems")) || []
  );

  const [cartTotalPrice, setCartTotalPrice] = useState();
  // let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];

  // localStorage.setItem('cartItems', JSON.stringify(cartItems));

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "scroll";
    };
  }, []);

  useEffect(() => {
    let totalPrice = 0;
    cartItems.forEach((item) => {
      const pricePerUnit = parseFloat(item.variants.nodes[0].price.amount);
      const totalValue = pricePerUnit * item.selectedQuantity;
      totalPrice += totalValue || 0; // Add total value of each product, defaulting to 0 if not set
    });

    // Update state with the new total price
    setCartTotalPrice(totalPrice);

    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]); // Update localStorage whenever cartItems changes

  const closeCart = () => {
    setCartOpen(false);
  };

  const handleQuantityChange = (index, newQuantity, product) => {
    // Make a copy of the cartItems array
    const updatedCartItems = [...cartItems];
    // Update the selectedQuantity of the product at the specified index
    updatedCartItems[index].selectedQuantity = newQuantity;
    // Calculate the total value of the product based on the new quantity
    // const pricePerUnit = parseFloat(
    //   updatedCartItems[index].product.variants.nodes[0].price.amount
    // );
    const pricePerUnit = parseFloat(product.variants.nodes[0].price.amount);
    const totalValue = pricePerUnit * newQuantity;
    // Update the state with the new cartItems array
    updatedCartItems[index].totalValue = totalValue;

    setCartItems(updatedCartItems);
  };

  const navigate = useNavigate();

  const NavigateToProductPage = (product) => {
    const extractedId = product.id.substring(product.id.lastIndexOf("/") + 1);
    closeCart();
    navigate(`/products/${encodeURIComponent(extractedId)}`);
  };

  const navigateToCheckout = () => {
    if (isAuthenticated) {
      navigate(`/checkout`);
    } else {
      navigate(`/login`);
    }
    closeCart();
  };

  const removeItemFromCart = (event,index) => {
    event.stopPropagation();
    const updatedCartItems  = [...cartItems];
    updatedCartItems.splice(index, 1);
    localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
    setCartItems(updatedCartItems);
  };


  return (
    <div
      id="cart"
      className="top-0 right-0 z-[99] fixed flex justify-center items-center w-screen h-screen"
    >
      <div
        className="bg-gray-400 bg-opacity-50 shadow-md w-[30%] md:w-[50%] lg:w-[70%] h-full"
        onClick={closeCart}
      ></div>

      {/* Main Container */}
      <div className="flex flex-col justify-start items-center bg-white shadow-md w-[70%] md:w-[50%] lg:w-[30%] h-full">
        <div className="flex justify-between items-center p-6 border-b w-full heading">
          <h3 className="font-primaryFont font-semibold text-lg uppercase tracking-wider">
            Cart
          </h3>
          <button className="ml-auto focus:outline-none" onClick={closeCart}>
            <RxCross2 className="text-2xl text-gray-500 hover:text-gray-700" />
          </button>
        </div>
        <div className="cart-item-container overflow-y-scroll">
          <div className="p-4 cart-card-container">
            {cartItems.map((product, index) => (
              <div
                onClick={() => NavigateToProductPage(product)}
                key={product.id}
                className="flex justify-between items-start gap-2 py-2 border-b w-full cart-card"
              >
                <div className="p-2 w-[25%] image-container">
                  <img src={product.featuredImage.url} alt={product.title} />
                </div>
                <div className="relative flex flex-col justify-start items-start pt-2 w-[70%] text-sm detail-container">
                  {/* <h2 className="mb-2 tracking-wider">
                    {product.title.split(" - ")[0]}
                  </h2> */}
                  <div className="flex justify-between items-center mb-2 w-full heading-container">
                  <h2 className="tracking-wider">
                    {product.title.split(" - ")[0]}
                  </h2>
                  <button
                    className="ml-auto focus:outline-none"
                    onClick={(event) =>  removeItemFromCart(event,index)}
                  >
                    <RxCross2 className="text-2xl text-gray-500 hover:text-gray-700" />
                  </button>
                </div>

                  <p className="text-xs">
                    <span className="font-semibold">Color:</span>{" "}
                    {product.options &&
                    product.options.find((option) => option.name === "Color")
                      ? product.options.find(
                          (option) => option.name === "Color"
                        ).values[0]
                      : "N/A"}
                  </p>
                  
                  <p className="text-xs">
                    <span className="font-semibold">Size:</span>{" "}
                    {product.selectedSize ? product.selectedSize : 'None'}
                  </p>
                  <p className="text-xs">
                    <span className="font-semibold">Quantity:</span>{" "}
                    {product.selectedQuantity}
                  </p>
                  <div className="relative flex justify-between items-center mt-2 w-full quantity-total-container">
                    <div className="relative flex justify-center items-center border quantity-container">
                      <span
                        className="hover:bg-black p-2 hover:text-white"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleQuantityChange(
                            index,
                            product.selectedQuantity - 1 > 0
                              ? product.selectedQuantity - 1
                              : 1,
                            product
                          );
                        }}
                      >
                        <AiOutlineMinus />
                      </span>
                      <input
                        type="text"
                        disabled
                        min="1"
                        value={product.selectedQuantity}
                        className="bg-white w-5 text-center"
                        placeholder="1"
                      />
                      <span
                        className="hover:bg-black p-2 hover:text-white"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleQuantityChange(
                            index,
                            product.selectedQuantity + 1,
                            product
                          );
                        }}
                      >
                        <AiOutlinePlus />
                      </span>
                    </div>
                    <div className="text-right w-full font-secondaryFont total-container">
                      <span className="font-semibold capitalize tracking-widest">
                        Rs.
                        {product.variants.nodes[0].price.amount *
                          product.selectedQuantity}
                        {/* Rs.{product.totalValue} */}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            
          </div>
        </div>
        {cartItems.length <= 0 ? (
              <p className="font-bold text-center text-red-500 tracking-wider">
                No Products{" "}
                <span className="text-blue-500 underline">
                  Please Add Products
                </span>
              </p>
            ) : (
              <div className="flex flex-col justify-between items-center gap-4 p-6 w-full checkout-container">
          <div className="flex justify-between items-center w-full font-secondaryFont text-sm uppercase total-container">
            <span className="font-semibold">subtotal</span>
            <span className="font-bold capitalizze">Rs. {cartTotalPrice}</span>
          </div>
          <div className="flex flex-col justify-center items-center gap-2 order-btn-container font-primaryFont">
            <p className="text-[10px] text-center text-primary">
              Shipping, taxes, and discount codes calculated at checkout.
            </p>

            <button
              onClick={navigateToCheckout}
              className="bg-black hover:bg-primary hover:shadow-md py-2 w-full font-semibold text-sm text-white uppercase tracking-wider"
            >
              place order
            </button>
          </div>
        </div>
            )}
        
      </div>
    </div>
  );
}

export default Cart;

/*const cartItems = [
    {
      id: 43243449680034,
      properties: null,
      quantity: 1,
      variant_id: 43243449680034,
      key: "43243449680034:9b63e891aade0b92344e857042f351bf",
      title: "Double Cuff Black Shirt - Black / XXL",
      price: 99900,
      original_price: 99900,
      presentment_price: 999,
      discounted_price: 99900,
      line_price: 99900,
      original_line_price: 99900,
      total_discount: 0,
      discounts: [],
      sku: "4MSS1813-10-XXL",
      grams: 300,
      vendor: "SNITCH",
      taxable: false,
      product_id: 7902789730466,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 99900,
      final_line_price: 99900,
      url: "/products/double-cuff-black-shirt?variant=43243449680034",
      featured_image: {
        aspect_ratio: 0.667,
        alt: "Double Cuff Black Shirt",
        height: 1200,
        url: "https://cdn.shopify.com/s/files/1/0420/7073/7058/products/4MSS1813-10-M2737_85b2534e-7886-4fcb-8da4-4d105eccf6a5.jpg?v=1682191059",
        width: 800,
      },
      image:
        "https://cdn.shopify.com/s/files/1/0420/7073/7058/products/4MSS1813-10-M2737_85b2534e-7886-4fcb-8da4-4d105eccf6a5.jpg?v=1682191059",
      handle: "double-cuff-black-shirt",
      requires_shipping: true,
      product_type: "Shirts",
      product_title: "Double Cuff Black Shirt",
      product_description:
        "\nThis Double Cuff Black Shirt is the perfect addition to your wardrobe. Made with a premium Satin fabric, this elegant shirt is designed to look polished and sophisticated at any party or special occasion. It features a double cuff with secure snap button closure, ensuring a fitted, comfortable fit. The perfect party wear shirt, it will turn heads and bring a sense of sophistication to any occasion.\nPRODUCT SPECIFICATION\n\nFull Sleeves\nSpread Collar \nDouble Cuff with Snap Button on Sleeve \nCurved Hem Design\n\nSpare Buttons Included\n\nFABRIC: 100% Satin Cotton \nFIT: Slim Fit\nSIZE: Model is wearing a M size \nModel Height: 6 Feet \nWASH CARE: Cold machine wash. For more details see the wash care label attached.\nActual colour of the product may vary slightly due to photographic lighting sources or your device.",
      variant_title: "Black / XXL",
      variant_options: ["Black", "XXL"],
      options_with_values: [
        {
          name: "Color",
          value: "Black",
        },
        {
          name: "Size",
          value: "XXL",
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
    {
      id: 44249257509026,
      properties: {},
      quantity: 1,
      variant_id: 44249257509026,
      key: "44249257509026:c038b6474cc1b6120ee180f47ec66408",
      title: "Whisper-Soft Navy Shirt - Navy / L",
      price: 119900,
      original_price: 119900,
      presentment_price: 1199,
      discounted_price: 119900,
      line_price: 119900,
      original_line_price: 119900,
      total_discount: 0,
      discounts: [],
      sku: "4MSS2719-03-L",
      grams: 300,
      vendor: "SNITCH",
      taxable: true,
      product_id: 8229707546786,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 119900,
      final_line_price: 119900,
      url: "/products/whisper-soft-navy-shirt?variant=44249257509026",
      featured_image: {
        aspect_ratio: 0.667,
        alt: "Whisper-Soft Navy Shirt",
        height: 1200,
        url: "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/4MSS2719-03-M22.jpg?v=1711523410",
        width: 800,
      },
      image:
        "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/4MSS2719-03-M22.jpg?v=1711523410",
      handle: "whisper-soft-navy-shirt",
      requires_shipping: true,
      product_type: "Shirts",
      product_title: "Whisper-Soft Navy Shirt",
      product_description:
        "The Whisper-Soft Navy Shirt is expertly crafted from polyester for a comfortable, relaxed fit. Its semi-transparent fabric adds a touch of elegance to any outfit. Enjoy the perfect balance of comfort and style with this versatile shirt.\nPRODUCT DESCRIPTION\n\nFull Sleeves\nSlightly Transparent\nCuban Collar \nStraight Hem Design\n\nSpare Buttons Included\n\nFABRIC: 100% Polyester \nFIT: Relaxed Fit\nSIZE: Model is wearing a M size \nModel Height: 6 Feet \nWASH CARE: Cold machine wash. For more details see the wash care label attached.\nActual Color of the product may vary slightly due to photographic lighting sources or your device. ",
      variant_title: "Navy / L",
      variant_options: ["Navy", "L"],
      options_with_values: [
        {
          name: "Color",
          value: "Navy",
        },
        {
          name: "Size",
          value: "L",
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
    {
      id: 43892016414882,
      properties: {},
      quantity: 1,
      variant_id: 43892016414882,
      key: "43892016414882:7382ef81cb381af90dc81793a0a51ced",
      title: "Yakuza Black Sukajan Bomber Jacket - Black / L",
      price: 299900,
      original_price: 299900,
      presentment_price: 2999,
      discounted_price: 299900,
      line_price: 299900,
      original_line_price: 299900,
      total_discount: 0,
      discounts: [],
      sku: "4MSK8570-01-L",
      grams: 500,
      vendor: "SNITCH",
      taxable: false,
      product_id: 8124834414754,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 299900,
      final_line_price: 299900,
      url: "/products/yakuza-black-sukajan-bomber-jacket-1?variant=43892016414882",
      featured_image: {
        aspect_ratio: 0.667,
        alt: "Yakuza Black Sukajan Bomber Jacket",
        height: 1200,
        url: "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/blackyakuzared-min.jpg?v=1702636111",
        width: 800,
      },
      image:
        "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/blackyakuzared-min.jpg?v=1702636111",
      handle: "yakuza-black-sukajan-bomber-jacket-1",
      requires_shipping: true,
      product_type: "Jackets",
      product_title: "Yakuza Black Sukajan Bomber Jacket",
      product_description:
        "This Yakuza Black Sukajan Bomber Jacket expertly combines iconic style with exclusive intricately embroidered details. Crafted from the highest quality material, this Sukajan jacket is an exclusive, timeless addition to any wardrobe.\nPRODUCT DESCRIPTION\n\nFull Sleeves\nVelour Fabric \nRibbed Collar\nSide Pocket \nEmbroidery \nCracked Print  \nStraight Hem\n\nFABRIC: 100% Cotton \nFIT: Relaxed Fit\nSIZE: Model is wearing a M size \nModel Height: 6 Feet \nWASH CARE: Cold machine wash. For more details see the wash care label attached.\nActual Color of the product may vary slightly due to photographic lighting sources or your device.\n",
      variant_title: "Black / L",
      variant_options: ["Black", "L"],
      options_with_values: [
        {
          name: "Color",
          value: "Black",
        },
        {
          name: "Size",
          value: "L",
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
    {
      id: 44063497289890,
      properties: {},
      quantity: 1,
      variant_id: 44063497289890,
      key: "44063497289890:6ba5d00dc7db562187b36e523d7c46a3",
      title: "Elegant Monotone Maroon Shirt - Maroon / S",
      price: 99900,
      original_price: 99900,
      presentment_price: 999,
      discounted_price: 99900,
      line_price: 99900,
      original_line_price: 99900,
      total_discount: 0,
      discounts: [],
      sku: "4MSS2654-08-S",
      grams: 300,
      vendor: "SNITCH",
      taxable: false,
      product_id: 8180932477090,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 99900,
      final_line_price: 99900,
      url: "/products/elegant-monotone-maroon-shirt?variant=44063497289890",
      featured_image: {
        aspect_ratio: 0.667,
        alt: "Elegant Monotone Maroon Shirt",
        height: 1200,
        url: "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/4MSS2654-08-M15.jpg?v=1710493390",
        width: 800,
      },
      image:
        "https://cdn.shopify.com/s/files/1/0420/7073/7058/files/4MSS2654-08-M15.jpg?v=1710493390",
      handle: "elegant-monotone-maroon-shirt",
      requires_shipping: true,
      product_type: "Shirts",
      product_title: "Elegant Monotone Maroon Shirt",
      product_description:
        "\nElegant Monotone Maroon Shirt provides a reliable, professional look and is designed to be comfortable while wearing. Its sophisticated form makes it suitable for a variety of occasions, from formal events to party gatherings.\nPRODUCT SPECIFICATION\n\nFull Sleeves\nSolid Pattern\nSpread Collar\n\nCurved Hem Design\nSpare Buttons Included\n\nFABRIC: 100% Cotton\nFIT: Slim Fit\nSIZE: Model is wearing a M size \nModel Height: 6 Feet \nWASH CARE: Cold machine wash. For more details see the wash care label attached.\nActual colour of the product may vary slightly due to photographic lighting sources or your device.",
      variant_title: "Maroon / S",
      variant_options: ["Maroon", "S"],
      options_with_values: [
        {
          name: "Color",
          value: "Maroon",
        },
        {
          name: "Size",
          value: "S",
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
  ];*/
